/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Grid, Typography, Typography2 } from '@coursera/cds-core';

import onDemandTutorialViewsApi from 'bundles/common/api/onDemandTutorialViewsApi';
import { VISIBILITY_KEY } from 'bundles/degree-home/components/v2/Calendar/constants/constants';
import CalendarSyncDropdown from 'bundles/degree-home/components/v3-dpm/components/Calendar/CalendarSyncDropdown';
import TrackedButton from 'bundles/page/components/TrackedButton';
import TrackedDiv from 'bundles/page/components/TrackedDiv';
import { Card } from 'bundles/program-loggedin-shared/components/Card';

import _t from 'i18n!nls/degree-home';

const styles = {
  textSpacing: () => css`
    margin-top: var(--cds-spacing-200);
  `,
};

export const CalendarSyncCard = () => {
  const [closed, setClosed] = React.useState(true);

  React.useEffect(() => {
    onDemandTutorialViewsApi.hasKey(VISIBILITY_KEY).then((result: boolean) => {
      setClosed(result);
    });
  }, []);

  const closeCard = () => {
    setClosed(true);
    onDemandTutorialViewsApi.storeKey(VISIBILITY_KEY);
  };

  if (closed) return null;

  return (
    <TrackedDiv
      trackingName="calendar_notification"
      trackClicks={false}
      requireFullyVisible={false}
      withVisibilityTracking={true}
      role="group"
      data-testid="calendar-sync-card"
    >
      <Card>
        {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
        <Typography variant="h2semibold">{_t('Don’t miss out on deadlines and events')}</Typography>
        <Typography2 component="p" css={styles.textSpacing}>
          {_t(
            'Add all your assignment deadlines and important dates to your calendar. You can also set it up later in Settings.'
          )}
        </Typography2>
        <Grid container alignItems="center" spacing={16} direction="row" css={styles.textSpacing}>
          <Grid item>
            <CalendarSyncDropdown />
          </Grid>
          <Grid item>
            <Button
              size="small"
              variant="ghost"
              component={TrackedButton}
              withVisibilityTracking={false}
              requireFullyVisible={false}
              trackingName="dismissed_calendar_sync_notification"
              data-testid="set-up-later"
              onClick={closeCard}
            >
              {_t('Set up later')}
            </Button>
          </Grid>
        </Grid>
      </Card>
    </TrackedDiv>
  );
};
